import * as React from 'react';
import * as styles from './styles.css';

export interface IYouTubeProps {
  videoId: string;
}

export function YouTube({ videoId }: IYouTubeProps) {
  return (
    <iframe
      className={styles['container']}
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
      allow="autoplay"
      allowFullScreen
    />
  );
}
